import { EcosystemAppPoliciesByAppId } from '../../../hooks/useAppPoliciesByAppIds';

export interface ClassicConnectInstallation {
  cloudId?: string;
  installedDate?: string;
  oauthClientId?: string;
  product: string;
  tenantBaseUrl?: string;
  version?: string;
}

export interface ClassicConnectedApp {
  avatarUrl?: string;
  contactLink?: string;
  installations: ClassicConnectInstallation[];
  key: string;
  name: string;
  privacyLink?: string;
  summary?: string;
  valid?: boolean;
  vendorName?: string;
}

export interface ClassicConnectedAppArisByWorkspace {
  [workspaceId: string]: string[];
}

export interface AppPoliciesByWorkspace {
  [workspaceId: string]: EcosystemAppPoliciesByAppId[];
}
